import { Column, Entity } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_query_store__tag')
export class QueryStoreTagEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__query_store__id',
		nullable: true,
		unsigned: true,
	})
	public fkQueryStoreId!: number | null;

	@Column('int', { name: '_fk__tag__id', nullable: true, unsigned: true })
	public fkTagId!: number | null;
}
